import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type FaqItemWithParsedAnswer } from '../../../../productPageDataAssembly/assembleFaqs'

interface ProductFaqsQuestionAndResponseProps {
  faq: FaqItemWithParsedAnswer
}

const ProductFaqsQuestionAndResponse: FC<
  ProductFaqsQuestionAndResponseProps
> = ({ faq }) => {
  const { faqItem, markdownParsedAnswer } = faq

  return (
    <div className="mb-5 rounded-s bg-light-primary-medium">
      <article className="p-5">
        <header className="mb-5">
          <h3 className="mb-2.5 text-m font-bold">{faqItem.question}</h3>
          {faqItem.personAsking ? (
            <span className="font-bold">
              <FormattedMessage id="productQuestions.label.personAsking" />{' '}
              {faqItem.personAsking}
            </span>
          ) : null}
        </header>
        <div>
          {faqItem.answer ? (
            <div
              className="prose mb-5 whitespace-normal"
              // eslint-disable-next-line react/no-danger -- the rule was disabled before a comment became required
              dangerouslySetInnerHTML={{
                __html: markdownParsedAnswer,
              }}
            />
          ) : null}
          {faqItem.personAnswering ? (
            <span className="italic">{faqItem.personAnswering}</span>
          ) : null}
        </div>
      </article>
    </div>
  )
}

export { ProductFaqsQuestionAndResponse }
